import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import {catchError, map, tap} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ReflectionService {

    public reflectionSelect = new BehaviorSubject(null);

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig) { }

    getReflectionByTable(data: any): Observable<any> {
        const reflectionUrl = `${this.restUrlsConf.appURL}/account/reflection/${data.tableName}.json`;

        return this.http.post(reflectionUrl , JSON.stringify(data))
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

    getReflectionsSubTable(params): Observable<any> {
        const reflectionUrl = `${this.restUrlsConf.appURL}/account/reflectionSubTable.json`;
        return this.http.get(reflectionUrl, {params})
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

    updateReflectionSelect(selected) {
        this.reflectionSelect.next(selected);
    }


}
